import { useEffect, useState } from "react";
import { useLang } from "../../i18n/LangContext";
import { usePublicSettings, fmtIntl, waHref } from "../../lib/publicSettings";

const WaGlyph = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round">
    <path d="M12 2.8a9.2 9.2 0 0 0-7.9 13.9L2.8 21.2l4.6-1.2A9.2 9.2 0 1 0 12 2.8Z" />
    <path fill="currentColor" stroke="none" d="M9.1 7.4c-.2-.4-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.3.3-.9.9-.9 2.2s.9 2.5 1 2.7c.1.2 1.8 2.9 4.5 3.9 2.2.9 2.7.7 3.1.6.5 0 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.2-.2-.5-.3l-1.7-.8c-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1-.3-.1-1.1-.4-2-1.3-.8-.7-1.3-1.5-1.4-1.8-.2-.3 0-.4.1-.5l.4-.5.3-.4c.1-.2 0-.3 0-.5l-.8-1.9Z" />
  </svg>
);

export const WhatsAppFab = () => {
  const { t } = useLang();
  const settings = usePublicSettings();
  const [typing, setTyping] = useState(false);

  useEffect(() => {
    const on = (e) => setTyping(Boolean(e.target.matches?.("input, textarea, select")));
    const off = () => setTyping(false);
    document.addEventListener("focusin", on);
    document.addEventListener("focusout", off);
    return () => { document.removeEventListener("focusin", on); document.removeEventListener("focusout", off); };
  }, []);

  const number = settings?.contact?.whatsapp;
  if (!number) return null;
  const label = t.waFab.label(fmtIntl(number));
  return (
    <a href={waHref(number, t.waFab.message)} target="_blank" rel="noopener noreferrer" className={`wa-fab${typing ? " is-typing" : ""}`}
      aria-label={label} title={label} data-testid="whatsapp-fab">
      <WaGlyph />
    </a>
  );
};
